"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as h } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const a = (_param)=>{
    var { color: c, size: o = 24 } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const l = h(), i = c !== null && c !== void 0 ? c : l ? t.colors.inverse : t.colors.neutralHigh, { skinName: s } = n();
    return s.match(/^o2/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ e("path", {
            fill: i,
            d: "M21.518 2.72a.76.76 0 0 0-.276-.576.65.65 0 0 0-.622-.108L8.519 5.64A.69.69 0 0 0 8 6.324v9.187a3.26 3.26 0 0 0-2.075-.72c-1.902 0-3.455 1.623-3.455 3.6C2.47 20.37 4.02 22 5.922 22s3.455-1.622 3.455-3.6V6.867l10.722-3.209v8.612a3.26 3.26 0 0 0-2.075-.72c-1.902 0-3.455 1.623-3.455 3.6 0 1.979 1.557 3.601 3.455 3.601s3.456-1.622 3.456-3.6c.038-.036.038-12.432.038-12.432"
        })
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ e("path", {
            fill: i,
            d: "M20.609 5.712c0-.546-.423-.997-.967-1.048l-9.285-2.482-.165-.022c-.443 0-.821.266-.984.644a1.05 1.05 0 0 0-.084.41v8.254c-.622-.46-1.383-.678-2.098-.694-.09-.003-.196-.003-.297-.003-1.543.014-3.344.924-3.344 3.448 0 2.52 1.812 3.442 3.361 3.465h.115q.094 0 .17-.003c1.485-.025 3.189-.885 3.334-3.148h.028V5.95l8.953 2.445v7.233c-.622-.46-1.39-.678-2.104-.695l-.291-.003c-1.544.014-3.345.925-3.345 3.448 0 2.521 1.812 3.443 3.361 3.465h.115q.094 0 .171-.002c1.55-.028 3.361-.947 3.361-3.449 0-.05-.01-.09-.014-.137h.014V5.712z"
        })
    }));
}, p = a;
export { p as default };
